/**
 * 模块: SearchPerformanceTabs Formatters
 * 职责: 表格数据格式化工具函数
 * 限制: <280行
 */

import React from 'react';
import { Tag } from 'antd';

/**
 * 格式化搜索量
 */
export const formatSearchVolume = (val: number): React.ReactNode => {
  return val > 0 ? val.toLocaleString() : '-';
};

/**
 * 格式化搜索量（带Tag）
 */
export const formatSearchVolumeTag = (val: number): React.ReactNode => {
  return val > 0 ? <Tag color="purple">{val.toLocaleString()}</Tag> : '-';
};

/**
 * 格式化百分比
 */
export const formatPercent = (val: number): string => {
  return `${val}%`;
};

/**
 * 格式化百分比（带Tag和颜色）
 */
export const formatPercentTag = (val: number, color: string): React.ReactNode => {
  return <Tag color={color}>{val}%</Tag>;
};

/**
 * 格式化优势百分比
 */
export const formatAdvantage = (val: number): React.ReactNode => {
  return <Tag color="gold">+{val}%</Tag>;
};

/**
 * 格式化价格优势
 */
export const formatPriceAdvantage = (val: number): React.ReactNode => {
  return <Tag color="green">-{val}%</Tag>;
};

/**
 * 格式化价格
 */
export const formatPrice = (val: number): string => {
  return `$${val}`;
};

/**
 * 格式化数字（千分位）
 */
export const formatNumber = (val: number): string => {
  return val.toLocaleString();
};

/**
 * 搜索量排序器
 */
export const searchVolumeSorter = (a: any, b: any): number => {
  return (a.search_volume || 0) - (b.search_volume || 0);
};

/**
 * 机会评分渲染器
 */
export const renderOpportunityScore = (val: number): React.ReactNode => {
  return <strong>{val.toFixed(0)}</strong>;
};

/**
 * 机会评分排序器
 */
export const opportunityScoreSorter = (a: any, b: any): number => {
  return a.opportunity_score - b.opportunity_score;
};

/**
 * ASIN占比渲染器（根据值动态着色）
 */
export const renderAsinShare = (val: number): React.ReactNode => {
  return <Tag color={val < 0.5 ? 'red' : 'orange'}>{val}%</Tag>;
};

